import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { clearUser } from "../redux/features/userSlice";
import { useAbility } from "../ability/AbilityContext";
import { logoutUser } from "../services/auth";
import { clearAuthCookies } from "../utils/cookie-storage/auth-cookie";
import { setLoggedOut } from "../config";
import RoutesConstant from "../constants/routes";

const useLogout = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { clearRolePermissions } = useAbility();
  const user = useSelector((state) => state.user?.user);

  const safeLogoutUser = async (payload) => {
    try {
      await logoutUser(payload);
    } catch (error) {
      console.error("Logout API failed:", error);
    }
  };

  const logout = async () => {
    const payload = {
      user_name: user?.user_name,
      user_type: "Admin",
    };

    if (user?.device_id) payload.device_id = user.device_id;

    await safeLogoutUser(payload);

    setLoggedOut(true);
    dispatch(clearUser());
    clearRolePermissions();
    clearAuthCookies();

    navigate(RoutesConstant.LOGIN);
  };

  return logout;
};

export default useLogout;